const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getSessionId = () => {
    let sid = sessionStorage.getItem("as_sid");
    if (!sid) {
        sid = crypto.randomUUID();
        sessionStorage.setItem("as_sid", sid);
    }
    return sid;
};

const getUtm = () => {
    let raw = sessionStorage.getItem("as_utm");
    if (raw === null) {
        const params = new URLSearchParams(window.location.search);
        const utm = {};
        for (const key of [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "utm_term",
            "utm_content",
        ]) {
            const v = params.get(key);
            if (v) utm[key] = v.slice(0, 120);
        }
        raw = JSON.stringify(utm);
        sessionStorage.setItem("as_utm", raw);
    }
    try {
        return JSON.parse(raw);
    } catch {
        return {};
    }
};

export const trackEvent = (type) => {
    try {
        const payload = {
            type,
            session_id: getSessionId(),
            path: window.location.pathname,
            ...getUtm(),
        };
        fetch(`${API}/events`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
            keepalive: true,
        }).catch(() => {});
        if (window.gtag) window.gtag("event", type);
        if (window.fbq) window.fbq("trackCustom", type);
    } catch {
        /* analytics must never break the page */
    }
};
